"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _ApplicationContext = require("./api/ApplicationContext");
var _Theme = _interopRequireDefault(require("./layout/Theme"));
var _SiteConfiguration = require("./api/auth/SiteConfiguration");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SecureApp extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleMessage", event => {
      const {
        defaultHasFramework,
        framework
      } = this.state;
      if (event.origin !== window.location.origin || typeof event.data !== 'string') {
        return;
      }
      try {
        const json = JSON.parse(event.data);
        const showFramework = json.showFramework && defaultHasFramework;
        if (typeof showFramework !== 'undefined' && framework !== showFramework) {
          this.setState({
            framework: showFramework
          });
        }
      } catch (e) {
        // for now, do nothing with an error
      }
    });
    _ApplicationContext.ApplicationContext.initialize(props.site);
    const {
      site
    } = props;
    const _defaultHasFramework = !site || typeof site.framework === 'undefined' || site.framework;
    const _framework = _defaultHasFramework;
    this.state = {
      basename: _ApplicationContext.ApplicationContext.getRouterBasename(),
      defaultHasFramework: _defaultHasFramework,
      framework: _framework,
      siteConfiguration: undefined
    };
    window.addEventListener('message', this.handleMessage);
  }
  componentDidMount() {
    var _this$props;
    if ((_this$props = this.props) !== null && _this$props !== void 0 && (_this$props = _this$props.site) !== null && _this$props !== void 0 && _this$props.isSiteConfigurationEnabled) {
      (0, _SiteConfiguration.getConfiguration)(_ApplicationContext.ApplicationContext.getClientId(), _ApplicationContext.ApplicationContext.getApiBasePath()).then(response => {
        this.setState({
          siteConfiguration: response.data
        });
      }).catch(() => {
        this.setState({
          siteConfiguration: {
            siteMenu: {}
          }
        });
      });
    }
  }
  render() {
    const {
      basename,
      siteConfiguration
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
      basename: basename
    }, /*#__PURE__*/_react.default.createElement(_Theme.default, (0, _SiteConfiguration.getSiteProperties)(this.props, siteConfiguration)));
  }
}
exports.default = SecureApp;
SecureApp.propTypes = {
  loader: _propTypes.default.func.isRequired,
  site: _propTypes.default.shape({
    siteId: _propTypes.default.number.isRequired,
    siteName: _propTypes.default.string.isRequired,
    siteTitle: _propTypes.default.string.isRequired,
    siteSubTitle: _propTypes.default.string.isRequired,
    siteTag: _propTypes.default.string.isRequired,
    siteDescription: _propTypes.default.string.isRequired,
    welcomeTitle: _propTypes.default.string.isRequired,
    contactUsEmail: _propTypes.default.string.isRequired,
    framework: _propTypes.default.bool,
    isSiteConfigurationEnabled: _propTypes.default.bool,
    public: _propTypes.default.shape({
      siteMenu: _propTypes.default.array
    })
  })
};
SecureApp.defaultProps = {
  site: undefined
};
//# sourceMappingURL=SecureApp.js.map